import { createSlice } from "@reduxjs/toolkit";

const statisticSlice = createSlice({
  name: "statistics",
  initialState: {
    ManagementStatsToggleStatus: "General",
    GoodsStatsToggleStatus: "Overview",
    PickingStatsToggleStatus: "Picking",
    ScheduleStatsToggleStatus: "General",
    GuideStatsToggleStatus: "Info",
    EditGuideStatsToggleStatus: "Info",
    ScanPrintStatsToggleStatus: "Scan Barcode",
    SettingStatsToggleStatus: "User",

    ScheduleDetails: {},
    APIDetails: null,
    APIDetailsGroupEvents: null,
    APIDetailsUser: null,
    APIDetailsUserEvents: null,
    APIDetailsCustomerTable: [],
    APIDetailsStaffTable: [],
    APIDetailsGroupTable: [],
    APIDetailsSupplierTable: [],
    APIDetailsItemsTable: [],
    APIDetailsScheduledata: null,
    APIDetailsdateSchedule: null,
    APIDetailsGroupUserdata: null,
    APIDetailsPermissionTable: [],
    APIDetailsGroupPermissionTable: [],
    APIDetailsMapPoints: [],
    APIDetailsMapSupplier:[],










  },
  reducers: {
    setStatus(state, action) {
      state.ManagementStatsToggleStatus = action.payload;
    },
    setScheduleDetails(state, action) {
      state.ScheduleDetails = action.payload;
    },
    setGoodsToggleStatus(state, action) {
      state.GoodsStatsToggleStatus = action.payload;
    },
    setPickingToggleStatus(state, action) {
      state.PickingStatsToggleStatus = action.payload;
    },
    setScheduleToggleStatus(state, action) {
      state.ScheduleStatsToggleStatus = action.payload;
    },
    setGuideToggleStatus(state, action) {
      state.GuideStatsToggleStatus = action.payload;
    },
    setEditGuideToggleStatus(state, action) {
      state.EditGuideStatsToggleStatus = action.payload;
    },
    setScanPrintToggleStatus(state, action) {
      state.ScanPrintStatsToggleStatus = action.payload;
    },
    setSettingStatsToggleStatus(state, action) {
      state.SettingStatsToggleStatus = action.payload;
    },
    setAPIDetails(state, action) {
      state.APIDetails = action.payload;
    },
    setAPIDetailsGroupEvents(state, action) {
      state.APIDetailsGroupEvents = action.payload;
    },
    setAPIDetailsUser(state, action) {
      state.APIDetailsUser = action.payload;
    },
    setAPIDetailsUserEvents(state, action) {
      state.APIDetailsUserEvents = action.payload;
    },
    setAPIDetailsCustomerTable(state, action) {
      state.APIDetailsCustomerTable = action.payload;
    },
    setAPIDetailsStaffTable(state, action) {
      state.APIDetailsStaffTable = action.payload;
    },
    setAPIDetailsGroupTable(state, action) {
      state.APIDetailsGroupTable = action.payload;
    },
    setAPIDetailsSupplierTable(state, action) {
      state.APIDetailsSupplierTable = action.payload;
    },
    setAPIDetailsItemsTable(state, action) {
      state.APIDetailsItemsTable = action.payload;
    },
    setAPIDetailsScheduledata(state, action) {
      state.APIDetailsScheduledata = action.payload;
    },
    setAPIDetailsdateSchedule(state, action) {
      state.APIDetailsdateSchedule = action.payload;
    },
    setAPIDetailsGroupUserdata(state, action) {
      state.APIDetailsGroupUserdata = action.payload;
    },
    setAPIDetailsPermissionTable(state, action) {
      state.APIDetailsPermissionTable = action.payload;
    },
    setAPIDetailsGroupPermissionTable(state, action) {
      state.APIDetailsGroupPermissionTable = action.payload;
    },
    setAPIDetailsMapPoints(state, action) {
      state.APIDetailsMapPoints = action.payload;
    },
    setAPIDetailsMapSupplier(state, action) {
      state.APIDetailsMapSupplier = action.payload;
    },
  },
});

export const {
  setStatus,
  setGoodsToggleStatus,
  setPickingToggleStatus,
  setScheduleToggleStatus,
  setScheduleDetails,
  setGuideToggleStatus,
  setEditGuideToggleStatus,
  setScanPrintToggleStatus,
  setAPIDetails,
  setAPIDetailsGroupEvents,
  setAPIDetailsUser,
  setAPIDetailsUserEvents,
  setAPIDetailsCustomerTable,
  setAPIDetailsStaffTable,
  setAPIDetailsGroupTable,
  setAPIDetailsSupplierTable,
  setAPIDetailsItemsTable,
  setAPIDetailsScheduledata,
  setAPIDetailsdateSchedule,
  setAPIDetailsGroupUserdata,
  setAPIDetailsPermissionTable,
  setAPIDetailsGroupPermissionTable,
  setAPIDetailsMapPoints,
  setAPIDetailsMapSupplier,
  setSettingStatsToggleStatus,

} = statisticSlice.actions;

export default statisticSlice.reducer;